// extracted by mini-css-extract-plugin
export default {"icon":"DeleteIcon_icon__Sj+g9"};